import React, { Component, useState } from 'react';
import {  } from 'react-native';
import firebase from 'firebase'
import { Icon, Button, Text, Modal, FormControl,View, Spinner, } from 'native-base';
import db, { getUserPath } from '../../acebase';
import { liveTTScoreboardButtonTextColor } from '../../../livettscoreboard.config';
import { liveTTScoreboardTheme } from "../../liveTTScoreboardTheme";
import Match from '../classes/Match';
import { createNewMatch } from '../functions/scoring';
import { createTeamMatchNewMatch } from '../functions/teammatches';


export default function TableNewMatchModal(props){

    let [selectedGames, setSelectedGames] = useState(5)
    let [loadingNewMatch, setLoadingNewMatch] = useState(false)

//console.log(props.route.params.tableID, selectedGames)


    return (
        <Modal avoidKeyboard isOpen={props.isOpen}>
            <Modal.Content>
                <Modal.CloseButton></Modal.CloseButton>
                <Modal.Header>Create New Match</Modal.Header>
                <Modal.Body>
                    <FormControl>
                        <FormControl.Label>Best Of Games:</FormControl.Label>
                        <View flexDirection={"row"} justifyContent="space-evenly">
                            <View padding={1}>
                                <Button variant={selectedGames === 1? "solid":"outline"}
                                onPress={()=>setSelectedGames(1)}
                                >
                                    <Text color={selectedGames===1 ?"white":"black"}>1</Text>
                                </Button>
                            </View>
                            <View padding={1}>
                                <Button variant={selectedGames === 3? "solid":"outline"}
                                onPress={()=>setSelectedGames(3)}
                                >
                                    <Text color={selectedGames===3 ?"white":"black"}>3</Text>
                                </Button>
                            </View>
                            <View padding={1}>
                                <Button variant={selectedGames === 5? "solid":"outline"}
                                onPress={()=>setSelectedGames(5)}
                                >
                                    <Text color={selectedGames===5 ?"white":"black"}>5</Text>
                                </Button>
                            </View>
                            <View padding={1}>
                                <Button variant={selectedGames === 7? "solid":"outline"}
                                onPress={()=>setSelectedGames(7)}
                                >
                                    <Text color={selectedGames===7 ?"white":"black"}>7</Text>
                                </Button>
                            </View>
                            <View padding={1}>
                                <Button variant={selectedGames === 9? "solid":"outline"}
                                onPress={()=>setSelectedGames(9)}
                                >
                                    <Text color={selectedGames===9 ?"white":"black"}>9</Text>
                                </Button>
                            </View>
                            
                        </View>
                        
                    </FormControl>
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={loadingNewMatch}
                    onPress={ async()=>{
                        setLoadingNewMatch(true)
                        if(props.isTeamMatch === true){
                            await createTeamMatchNewMatch(props.teamMatchID, selectedGames, props.tableNumber)
                        }
                        else {
                            await createNewMatch(props.route.params.tableID, selectedGames)
                        }
                        
                        
                        props.onClose()
                        setLoadingNewMatch(false)
                    }}
                    >
                        {loadingNewMatch ? 
                        <Spinner color={liveTTScoreboardButtonTextColor}></Spinner>
                        :
                        <Text color={liveTTScoreboardButtonTextColor}>Create Match</Text>

                    }
                        
                    </Button>
                </Modal.Footer>
            </Modal.Content>
        </Modal>
    )
}